import { useContext, useMemo } from 'react';
import { ProjectDetailsContext } from '@/screens/Project.Main/Context';

/**
 * Hook that returns the current project data with a slug property for compatibility.
 * In genai-platform, we use the project ID as the slug since actual slugs are not implemented.
 * This hook adapts sentiment's useProjectOrLatestChild pattern to work with genai-platform's
 * ProjectDetailsContext structure.
 * 
 */
export const useProjectOrLatestChild = () => {
  const { query } = useContext(ProjectDetailsContext);

  return useMemo(() => {
    if (!query.data) {
      return null;
    }

    // Return project data with slug property mapped from id for compatibility
    // This matches the structure that sentiment's Highlights component expects
    return {
      ...query.data.project,
      slug: query.data.project.id.toString(),
    };
  }, [query.data]);
};